export default Object.freeze({
	EFECTIVO: '01',
	CHEQUE_NOMINATIVO: '02',
	TRANSFERENCIA_ELECTRONICA: '03',
	TARJETA_DE_CREDITO: '04',
	TARJETA_DE_DEBITO: '28',
	INTERMEDIARIO_PAGOS: '31',
})
